module.exports = __webpack_public_path__ + "static/media/mbl-subcapital.ce927945.jpg";